import { translate } from 'i18n/i18n'

// TODO: Come back and clean all this label stuff up...

export const threeItemLabel = (x: [string, string, string]) => {
  return translate.phrases.templates('{{labelA}} ({{labelB}}) {{labelC}}', {
    labelA: x[0],
    labelB: x[1],
    labelC: x[2],
  })
}

export const twoItemLabel = (x: [string, string]) => {
  return translate.phrases.templates('{{labelA}} ({{labelB}})', {
    labelA: x[0],
    labelB: x[1],
  })
}
